import React, { useEffect, useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {SYSTEM_BLUE_BACKGROUND_LIGHT} from "../../../constants/general-constants";
import UtilisationFloorPanelDeskCharts from "./UtilisationFloorPanelDeskCharts";

export default function UtilisationFloorPlanDeskInfoModal({ isOpen, onClose }) {
	const [displayCharts, setDisplayCharts] = useState("flex");
	const [displayCamera, setDisplayCamera] = useState("none");
  if (!isOpen) return null; // Dont render when closed

	

	const viewCamera = () => {
		if(displayCharts === "flex"){
			setDisplayCharts("none");
			setDisplayCamera("flex");
		}
		else{
			setDisplayCharts("flex");
			setDisplayCamera("none");
		}
	};

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)", // dark overlay
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "10px",
          padding: "20px",
          left:"80px",
          top:"100px",
          bottom:"140px",
          right:"320px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
          position: "fixed",
          flexWrap:'wrap'
        }}
      >
        {/* Close button */}
       <div style={{display:'flex', width:'100%', justifyContent:'space-between'}}>
        <h2 style={{ marginTop: 0, marginBottom: "15px" }}>
          Desk Information
        </h2>

         <FontAwesomeIcon icon="times" style={{display:'flex', marginRight:'0px', color:'black', width:'20px', height:'20px', cursor:'pointer'}} onClick={onClose}/>
       </div>
       	<div style={{display:"flex", width:"100%", flexWrap:'wrap', alignItems:"top"}}>  
					<div style={{display:'flex', flexDirection:'column', width:"350px"}}>
						<img src="desk.jpg" style={{display:'flex', marginTop:'5px', borderRadius:'10px', width:'350px'}}/>
						<div style={{display:'flex', fontSize:'16px', color:'black', marginTop:"20px", fontWeight:'bold'}}>
							A1-02-897: Desk
						</div>
						<div style={{display:'flex', fontSize:'14px', color:'black', marginTop:"10px", width:'350px'}}>
							This is an A1 type desk.  Single occupancy, single seat and desk combination.  Usually provided with power sockets, storage and a Monitor.
						</div>
						<div style={{display:'flex', alignItems:"center", border:'2px solid ' + SYSTEM_BLUE_BACKGROUND_LIGHT, borderRadius:"10px", width:'350px', marginTop:"20px"}}>
							<FontAwesomeIcon icon="camera" style={{display:'flex', margin:'10px', color:SYSTEM_BLUE_BACKGROUND_LIGHT, width:'50px', height:'50px', cursor:'pointer'}} onClick={viewCamera}/>
							<div style={{display:'flex', fontSize:'16px', color:'black', marginLeft:"10px"}}>
								View location
							</div>
						</div>
						
					</div>
					<div style={{display:displayCharts, marginLeft:'20px', marginTop:'0px', width:'calc(100% - 370px)', height:'424px', borderRadius:'10px'}}>
						<UtilisationFloorPanelDeskCharts/>
					</div>
					 <iframe style={{display:displayCamera, marginLeft:'20px', marginTop:'5px', width:'calc(100% - 370px)', height:'624px', borderRadius:'10px'}} src="https://tour.giraffe360.com/addd9e3d5b1f47e1b82bb64c672baf16" frameBorder='none'/>
      	</div>
     	</div>
    </div>
  );
}

















